<!--  -->
<template>
  <div class="">
    <WrapCard title="物流产品管理">
      <JiuyuTable :tabelParams="tabelParams" :requestParams="requestParams">
        <!-- 状态 -->
        <template v-slot="row">
          <el-button size="mini" type="primary" @click="detail(row)"
            >查看</el-button
          >
          <el-button size="mini" type="warning" @click="edit(row)"
            >修改</el-button
          >
        </template>
      </JiuyuTable>
    </WrapCard>
    <el-dialog
      title="物流产品管理修改"
      :visible.sync="AddDialogVisible"
      width="41%"
      center
      :show-close="false"
    >
      <div>
        <el-form
          :model="addObject"
          :rules="rules"
          ref="addObject"
          label-width="100px"
          class="demo-ruleForm"
        >
          <div>
            <el-form-item
              style="display: inline-block"
              :rules="{
                required: true,
                message: '请输入产品名称',
                trigger: 'blur',
              }"
              label="产品名称"
              prop="name"
            >
              <el-input
                disabled
                size="mini"
                v-model="addObject.name"
              ></el-input>
            </el-form-item>
            <el-form-item
              style="display: inline-block"
              :rules="{
                required: true,
                message: '请输入起运地',
                trigger: 'blur',
              }"
              label="起运地"
              prop="pol"
            >
              <el-input disabled size="mini" v-model="addObject.pol"></el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item
              style="display: inline-block"
              :rules="{
                required: true,
                message: '请输入目的地',
                trigger: 'blur',
              }"
              label="目的地"
              prop="pod"
            >
              <el-input disabled size="mini" v-model="addObject.pod"></el-input>
            </el-form-item>
            <el-form-item
              style="display: inline-block"
              :rules="{
                required: true,
                message: '请输入运输方式',
                trigger: 'blur',
              }"
              label="运输方式"
              prop="transportType"
            >
              <el-input
                disabled
                size="mini"
                v-model="addObject.transportType"
              ></el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item
              label-width="101px"
              style="display: inline-block"
              :rules="{
                required: true,
                message: '请输入派送时效(起)',
                trigger: 'blur',
              }"
              label="派送时效(起)"
              prop="agingFrom"
            >
              <el-input
                size="mini"
                :disabled="showDetail"
                v-model="addObject.agingFrom"
              ></el-input>
            </el-form-item>
            <el-form-item
              label-width="101px"
              style="display: inline-block"
              :rules="{
                required: true,
                message: '请输入派送时效(起)',
                trigger: 'blur',
              }"
              label="派送时效(起)"
              prop="agingTo"
            >
              <el-input
                size="mini"
                :disabled="showDetail"
                v-model="addObject.agingTo"
              ></el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item
              style="display: inline-block"
              :rules="{
                required: true,
                message: '请输入计费系数',
                trigger: 'blur',
              }"
              label="计费系数"
              prop="chargeCoefficient"
            >
              <el-input
                size="mini"
                :disabled="showDetail"
                v-model="addObject.chargeCoefficient"
              ></el-input>
            </el-form-item>
            <el-form-item
              style="display: inline-block"
              :rules="{
                required: true,
                message: '请输入最低重量',
                trigger: 'blur',
              }"
              label="最低重量"
              prop="minimumWeight"
            >
              <el-input
                size="mini"
                :disabled="showDetail"
                v-model="addObject.minimumWeight"
              ></el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item
              style="display: inline-block"
              :rules="{
                required: true,
                message: '请输入最低体积',
                trigger: 'blur',
              }"
              label="最低体积"
              prop="minimumCbm"
            >
              <el-input
                size="mini"
                :disabled="showDetail"
                v-model="addObject.minimumCbm"
              ></el-input>
            </el-form-item>
            <el-form-item
              style="display: inline-block"
              :rules="{
                required: true,
                message: '请输入标签1',
                trigger: 'blur',
              }"
              label="标签1"
              prop="label1"
            >
              <el-input
                size="mini"
                :disabled="showDetail"
                v-model="addObject.label1"
              ></el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item
              style="display: inline-block"
              :rules="{
                required: true,
                message: '请输入标签2',
                trigger: 'blur',
              }"
              label="标签2"
              prop="label2"
            >
              <el-input
                size="mini"
                :disabled="showDetail"
                v-model="addObject.label2"
              ></el-input>
            </el-form-item>
            <el-form-item
              style="display: inline-block"
              :rules="{
                required: true,
                message: '请输入标签3',
                trigger: 'blur',
              }"
              label="标签3"
              prop="label3"
            >
              <el-input
                size="mini"
                :disabled="showDetail"
                v-model="addObject.label3"
              ></el-input>
            </el-form-item>
          </div>

          <el-form-item
            :rules="{
              required: true,
              message: '请输入下单须知',
              trigger: 'blur',
            }"
            label="下单须知"
            prop="remark"
          >
            <el-input
              type="textarea"
              size="mini"
              :disabled="showDetail"
              v-model="addObject.remark"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="cancel()">取 消</el-button>
        <el-button size="mini" type="primary" @click="submitForm('addObject')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      v-if="showObject"
      title="查看物流产品管理"
      :visible.sync="showDetail"
      width="45%"
      center
    >
      <div style="display: flex; flex-wrap: wrap">
        <div
          v-for="(item, index) in showObjectDetail"
          :key="index"
          style="width: 220px; margin: 10px 0"
          :style="{ width: item.prop == 'remark' ? '100%' : '220px' }"
        >
          <div style="display: inline-block; color: #999999; width: 80px">
            <div>{{ item.name }}</div>
          </div>
          <span>{{ showObject[item.prop] }}</span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="showDetail = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import qs from "qs";
import _ from "lodash";
import myUtils from "./../../../common/jackUtils";
import WrapCard from "./jack-components/wrap-card";
import JiuyuSearchForm from "./jack-components/jiuyu-search-form";
import JiuyuTable from "./jack-components/jiuyu-table";
export default {
  components: { WrapCard, JiuyuTable },
  data() {
    return {
      showObjectDetail: [
        { name: "产品名称", prop: "name" },
        { name: "起运地", prop: "pol" },
        { name: "目的地", prop: "pod" },
        { name: "运输方式", prop: "transportTypeMsg" },
        { name: "派送时效(起)", prop: "agingFrom" },
        { name: "派送时效(始)", prop: "agingTo" },
        { name: "计费系数", prop: "chargeCoefficient" },
        { name: "最低重量", prop: "minimumWeight" },
        { name: "最低体积", prop: "minimumCbm" },
        { name: "标签1", prop: "label1" },
        { name: "标签2", prop: "label2" },
        { name: "标签3", prop: "label3" },
        { name: "下单须知", prop: "remark" },
      ],
      showObject: {
        id: "",
        name: "",
        code: "",
        pol: "",
        polId: "",
        pod: "",
        podId: "",
        transportType: "",
        transportTypeMsg: "",
        agingFrom: "",
        agingTo: "",
        chargeCoefficient: "",
        minimumWeight: "",
        minimumCbm: "",
        label1: "",
        label2: "",
        label3: "",
        remark: "",
      },
      rules: {
        sectionName: [
          { required: true, message: "请输入模板名称", trigger: "blur" },
        ],
      },
      addObject: {
        id: "",
        name: "",
        code: "",
        pol: "",
        polId: "",
        pod: "",
        podId: "",
        transportType: "",
        transportTypeMsg: "",
        agingFrom: "",
        agingTo: "",
        chargeCoefficient: "",
        minimumWeight: "",
        minimumCbm: "",
        label1: "",
        label2: "",
        label3: "",
        remark: "",
      },
      clearAll: () => {},
      AddDialogVisible: false,
      showDetail: false,
      list: [],
      // 组件数据
      requestParams: {
        // base
        curPage: 1,
        pageSize: 10,
        total: 0,
      },
      // 表格
      tabelParams: {
        tabelStyle: {
          margin: "10px 0",
          minWidth: "980px",
        },
        hideOperate: false,
        operateWidth: "150px",
        size: "mini",
        datas: {
          tableData: () => {
            return this.list;
          },
          // 表头数据
          innerData: () => {
            return [
              // 需要序号就添加 type
              { name: "序号", value: "", type: "index", width: "60" },
              { name: "产品名称", value: "name" },
              { name: "起运地", value: "pol" },
              { name: "目的地", value: "pod" },
              { name: "运输方式", value: "transportTypeMsg" },
              { name: "派送时效(起)", value: "agingFrom" },
              { name: "派送时效(始)", value: "agingTo" },
              { name: "计费系数", value: "chargeCoefficient" },
              { name: "最低重量", value: "minimumWeight" },
              { name: "最低体积", value: "minimumCbm" },
              { name: "标签1", value: "label1" },
              { name: "标签2", value: "label2" },
              { name: "标签3", value: "label3" },
              { name: "下单须知", value: "remark" },
              //  <template slot-scope="scope">
              //     <span v-if="scope.row.state == 1">草稿</span>
              //     <span v-if="scope.row.state == 2">发布</span>
              //     <span v-if="scope.row.state == 3">作废</span>
              //   </template>
            ];
          },
        },
        event: {
          sizeChange: (val) => {
            // console.log(this);
            this.requestParams.pageSize = val;
            this.getList();
          },
          currentChange: (val) => {
            this.requestParams.curPage = val;
            this.getList();
          },
        },
        tableEvent: {
          needCopy: true,
          getListById: (id, val) => {
            // console.log(id);
            return this.getListById(id);
          },
          updatestate: (id, val) => {
            // console.log(id,val);
            return this.updatestate(id, val);
          },
          copy: (id) => {
            // console.log(id,val);
            return this.copy(id);
          },
        },
      },
    };
  },
  computed: {
    showName() {
      // let name = !this.addObject.id ? "添加计费模板" : "修改计费模板";
      // if (this.showDetail) {
      //   name = "查看模板信息";
      // }
      return "name";
    },
  },
  watch: {},
  methods: {
    detail(row) {
      this.showObject = row.row;
      //  this.submitForm('addObject')
      this.showDetail = true;
    },
    cancel() {
      this.AddDialogVisible = false;
      setTimeout(() => {
        this.showDetail = false;
      }, 300);
      this.clearAll();
    },
    add(id) {
      // row.row.id
      // id ? (this.addObject.id = id) : "";
      this.axios
        .post(`/carrier/product/updateCarrierLogisticsProduct`, this.addObject)
        .then((res) => {
          if (res.data.code == 200) {
            this.$message.success("修改成功");
            this.getList();
            this.cancel();
          } else {
            this.$message.info(res.data.message);
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    edit(row) {
      this.axios
        .get(`/carrier/product/getCarrierLogisticsProductInfo/${row.row.id}`)
        .then((res) => {
          let { data } = res;
          if (data.code == 200) {
            this.addObject = data.data;
          } else {
            this.$message.info(res.data.message);
          }
        })
        .catch((res) => {
          console.log(res);
        });
      // this.addObject = row.row;
      this.AddDialogVisible = true;
    },
    getList(isQuery) {
      this.getBaseList(
        {
          methods: "post",
          params: {
            pageNum: this.requestParams.curPage,
            pageSize: this.requestParams.pageSize,
          },
        },
        "/carrier/product/getCarrierLogisticsProductList",
        "获取线路商物流产品列表",
        "list"
      );
    },
    getBaseList(methods, url, name, listName) {
      this.axios[methods.methods](
        `${url}`,
        methods.params ? methods.params : ""
      )
        .then((res) => {
          console.log(`------------获取 ${name}-------------`);
          console.log(res.data.data);
          if (res.data.code == 200) {
            this[listName] =
              (res.data.data &&
                res.data.data.list.length &&
                res.data.data.list) ||
              this.$message.info(`${name} 没有相关数据`);
            this.requestParams.total = res.data.data.total;
          } else {
            this.$message.info(res.data.message);
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // alert("submit!");
          this.add();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },

  created() {
    this.getList();
    myUtils.clearAddObject(this, "addObject");
  },
  mounted() {},
};
</script>
<style  scoped>
.el-form-item {
  margin: 0 0 18px 0;
}
</style>


// WEBPACK FOOTER //
// src/components/QuotationManagement/Logistics.vue